import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const NUMS = ["01", "02", "03", "04"];

export default function Process() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="surec" className="relative py-24 lg:py-32 bg-[#191C22]" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="glow-badge rounded-full px-4 py-1.5 text-xs font-medium tracking-widest uppercase">
            {t.process.badge}
          </span>
          <h2 className="mt-6 font-heading font-black tracking-tighter text-white text-3xl md:text-5xl max-w-2xl">
            {t.process.title_pre}
            <span className="text-[#5B7FFF]">{t.process.title_accent}</span>
          </h2>
        </motion.div>

        <div ref={ref} className="mt-16 relative">
          <div className="absolute start-[27px] md:start-[43px] top-0 bottom-0 w-px bg-white/10" />
          <motion.div
            style={{ scaleY: lineScale }}
            className="absolute start-[27px] md:start-[43px] top-0 bottom-0 w-px bg-[#5B7FFF] origin-top shadow-[0_0_12px_rgba(91,127,255,0.6)]"
          />

          <div className="flex flex-col gap-14 md:gap-20">
            {t.process.steps.map((step, i) => (
              <motion.div
                key={NUMS[i]}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="relative flex gap-8 md:gap-14 items-start"
                data-testid={`process-step-${i}`}
              >
                <div className="relative z-10 shrink-0 w-14 h-14 md:w-[88px] md:h-[88px] rounded-full glass-card flex items-center justify-center">
                  <span className="font-heading font-black text-lg md:text-3xl tracking-tighter text-[#5B7FFF]">
                    {NUMS[i]}
                  </span>
                </div>
                <div className="pt-1 md:pt-4 max-w-2xl">
                  <h3 className="font-heading font-bold text-white text-lg md:text-lg tracking-tight">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed">{step.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
